import React from 'react';
import { Space, Typography, Button, Dropdown, Modal } from 'antd';
import { 
    LogoutOutlined, 
    ManOutlined, 
    WomanOutlined, 
    MoreOutlined, 
    ExclamationCircleOutlined,
    DoubleRightOutlined
} from '@ant-design/icons';
import { useChat } from '../../context/ChatContext';

const { Text } = Typography;

const ChatHeader = ({ partnerInfo, onLeave, onNext, partnerLeft }) => {
    const { reportPartner, darkMode } = useChat();
    const isMale = partnerInfo?.gender === 'male';

    const handleReport = () => {
        Modal.confirm({
            title: 'Զեկուցել օգտատիրոջը',
            icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
            content: 'Վստա՞հ եք, որ ցանկանում եք զեկուցել այս օգտատիրոջը անպատշաճ վարքի համար:',
            okText: 'Այո, զեկուցել',
            okType: 'danger',
            cancelText: 'Չեղարկել',
            onOk() {
                reportPartner('inappropriate_behavior');
            },
        });
    };

    const items = [
        {
            key: 'report',
            label: 'Զեկուցել',
            danger: true,
            icon: <ExclamationCircleOutlined />,
            onClick: handleReport
        }
    ];
    
    const handleLeaveClick = () => {
        Modal.confirm({
            title: 'Դուրս գալ չատից',
            icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
            content: 'Վստա՞հ եք, որ ցանկանում եք լքել այս զրույցը:',
            okText: 'Այո',
            cancelText: 'Ոչ',
            onOk() {
                onLeave();
            },
        });
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <Space direction="vertical" size={0}>
                <Space>
                    <div style={{ 
                        width: 32, 
                        height: 32, 
                        borderRadius: '50%', 
                        background: isMale ? (darkMode ? '#153448' : '#e6f4ff') : (darkMode ? '#43102d' : '#fff0f6'),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: isMale ? '#1677ff' : '#eb2f96'
                    }}>
                        {isMale ? <ManOutlined /> : <WomanOutlined />}
                    </div>
                    <div>
                        <Text strong style={{ display: 'block', lineHeight: 1.2 }}>Անծանոթ</Text>
                        {partnerInfo && (
                            <Text type="secondary" style={{ fontSize: '11px' }}>
                                {partnerInfo.age} տարեկան
                            </Text>
                        )}
                    </div>
                </Space>
            </Space>
            
            <Space>
                {!partnerLeft && (
                    <Button 
                        icon={<DoubleRightOutlined />} 
                        onClick={onNext}
                        type="primary"
                        ghost
                        style={{ borderRadius: 8, height: 32, display: 'flex', alignItems: 'center' }}
                    >
                        <span className="hide-mobile">Հաջորդը</span>
                    </Button>
                )}
                
                <Button 
                    danger 
                    type="text"
                    icon={<LogoutOutlined />} 
                    onClick={handleLeaveClick}
                    style={{ borderRadius: 8, height: 32, width: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                />

                <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
                    <Button type="text" icon={<MoreOutlined />} style={{ borderRadius: 8, height: 32, width: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
                </Dropdown>
            </Space>

            <style>{`
                @media (max-width: 480px) {
                    .hide-mobile { display: none; }
                }
            `}</style>
        </div>
    );
};

export default ChatHeader;